import React from 'react';
import { Row, Col, FormGroup, Label } from 'reactstrap';
import { Field, ErrorMessage } from "formik";

const GamificationAttendancePoints = () => {
    return (
        <>
            <div className="mb-4">
                <h5 className="fw-bold mb-1">Pontuação por Frequência</h5>
                <p className="text-muted mb-0 font-size-13">Defina o XP concedido por presenças e faltas.</p>
            </div>
            
            <Row className="g-4">
                <Col md={6}>
                    <div className="p-4 border-top rounded-0 h-100">
                        <h6 className="text-primary fw-bold font-size-13 mb-3 d-flex align-items-center">
                            <i className="mdi mdi-account-outline me-2 font-size-18"></i>
                            Aluno
                        </h6>
                        <FormGroup className="mb-3">
                            <Label className="fw-semibold text-muted small">Presença Confirmada</Label>
                            <div className="input-group">
                                <Field type="number" className="form-control rounded-0" name="memberAttendancePresent" />
                                <span className="input-group-text bg-primary text-white border-0 fw-bold rounded-0">XP</span>
                            </div>
                            <ErrorMessage name="memberAttendancePresent" component="div" className="text-danger mt-1 font-size-12" />
                        </FormGroup>
                        <FormGroup className="mb-3">
                            <Label className="fw-semibold text-muted small">Falta Justificada</Label>
                            <div className="input-group">
                                <Field type="number" className="form-control rounded-0" name="memberAttendanceExcused" />
                                <span className="input-group-text bg-primary text-white border-0 fw-bold rounded-0">XP</span>
                            </div>
                            <ErrorMessage name="memberAttendanceExcused" component="div" className="text-danger mt-1 font-size-12" />
                        </FormGroup>
                        <FormGroup className="mb-0">
                            <Label className="fw-semibold text-muted small">Falta Injustificada</Label>
                            <div className="input-group">
                                <Field type="number" className="form-control rounded-0" name="memberAttendanceUnexcused" />
                                <span className="input-group-text bg-secondary text-white border-0 fw-bold rounded-0">XP</span>
                            </div>
                            <ErrorMessage name="memberAttendanceUnexcused" component="div" className="text-danger mt-1 font-size-12" />
                        </FormGroup>
                    </div>
                </Col>

                <Col md={6}>
                    <div className="p-4 bg-light rounded-0 h-100">
                        <h6 className="text-info fw-bold font-size-13 mb-3 d-flex align-items-center">
                            <i className="mdi mdi-teach me-2 font-size-18"></i>
                            Professor
                        </h6>
                        <FormGroup className="mb-3">
                            <Label className="fw-semibold text-muted small">Presença Confirmada</Label>
                            <div className="input-group">
                                <Field type="number" className="form-control rounded-0" name="teacherAttendancePresent" />
                                <span className="input-group-text bg-info text-white border-0 fw-bold rounded-0">XP</span>
                            </div>
                            <ErrorMessage name="teacherAttendancePresent" component="div" className="text-danger mt-1 font-size-12" />
                        </FormGroup>
                        <FormGroup className="mb-3">
                            <Label className="fw-semibold text-muted small">Falta Justificada</Label>
                            <div className="input-group">
                                <Field type="number" className="form-control rounded-0" name="teacherAttendanceExcused" />
                                <span className="input-group-text bg-info text-white border-0 fw-bold rounded-0">XP</span>
                            </div>
                            <ErrorMessage name="teacherAttendanceExcused" component="div" className="text-danger mt-1 font-size-12" />
                        </FormGroup>
                        <FormGroup className="mb-0">
                            <Label className="fw-semibold text-muted small">Falta Injustificada</Label>
                            <div className="input-group">
                                <Field type="number" className="form-control rounded-0" name="teacherAttendanceUnexcused" />
                                <span className="input-group-text bg-secondary text-white border-0 fw-bold rounded-0">XP</span>
                            </div>
                            <ErrorMessage name="teacherAttendanceUnexcused" component="div" className="text-danger mt-1 font-size-12" />
                        </FormGroup>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default GamificationAttendancePoints;
